import { connect } from 'react-redux'
import { Dispatch } from 'duck/store'
import { triggerDealReanalysisBegin } from 'scenes/Dashboard/data/deals/actions'
import { Deal } from 'scenes/Dashboard/data/deals/types'

import ReanalyzeButton, { ReanalyzeButtonProps } from './ReanalyzeButton.presentational'

function mapDispatchToProps(dispatch: Dispatch, { dealId, isAdmin }: ContainerProps): DispatchProps {
  return {
    onClick: () => dispatch(triggerDealReanalysisBegin(dealId, isAdmin)),
  }
}

type DispatchProps = Pick<ReanalyzeButtonProps, 'onClick'>

type ContainerProps = {
  dealId: Deal['id']
  isAdmin?: boolean
}

export default connect(undefined, mapDispatchToProps)(ReanalyzeButton)
